/**
 * Janela REAL de validade do JWT no backend.
 *
 * O backend valida o JWT manualmente pelo `timestamp` do payload contra uma
 * constante interna de 64800s/18h (`exclusivo/core/utils.py`, validate_jwt).
 * O campo `timeout` retornado pelo `/login/` é 3600 hardcoded e NÃO reflete a
 * validade do JWT — por isso o cálculo de expiração usa esta constante local
 * (espelho documentado), não o `state.auth.timeout`.
 *
 * Follow-up backend: expor o timeout real no /login/ e /refresh-token/; quando
 * existir, o FE deve preferir o valor do servidor.
 * Rede de segurança contra drift: o 403 'JWT Inválido' → logout limpo
 * (tokenError.ts) continua valendo independente desta constante.
 */
export const JWT_SESSION_SECONDS = 64800; // 18h — espelho de utils.py:validate_jwt

export const SESSION_CHECK_INTERVAL_MS = 3 * 60 * 1000; // 3 min

// Renova quando restar menos de 50% da vida (9h) — o usuário ativo nunca
// chega perto da expiração; antes o limiar era 9 min (só renovaria de
// madrugada, com o navegador fechado → 0 chamadas ao /refresh-token/).
export const REFRESH_AT_REMAINING_MS = (JWT_SESSION_SECONDS * 1000) / 2;

// Backoff exponencial após falha do refresh. Sem ele, a janela de tentativa de
// 9h somada ao tick de 3 min e ao visibilitychange geraria ~180 PUTs e ~180
// eventos Sentry por aba numa indisponibilidade do backend.
export const REFRESH_BACKOFF_BASE_MS = SESSION_CHECK_INTERVAL_MS; // 3 min
export const REFRESH_BACKOFF_MAX_MS = 30 * 60 * 1000; // teto de 30 min
